import { request, unwrap } from '../client';
import type { ApiResponse, GrantProductAdminRequest, ProductAdminDto } from '../types';

// SASADM-0105 (saas-auth SASATH-0211) — the operators appointed to administer one
// product's tenants (`product_admins`). SUPER_ADMIN-only. Grants are append-only
// and idempotent (`201` new · `200` already-active-same-role); revokes are soft,
// so the list is active-only unless `includeRevoked=true`.
const base = (productId: number) => `/api/saas-admin/products/${productId}/admins`;

export const productAdminsApi = {
  async list(productId: number, includeRevoked = false): Promise<ProductAdminDto[]> {
    const res = await request<ApiResponse<ProductAdminDto[]>>(
      'GET',
      `${base(productId)}?includeRevoked=${includeRevoked}`,
    );
    return unwrap(res);
  },

  async grant(productId: number, req: GrantProductAdminRequest): Promise<ProductAdminDto> {
    const res = await request<ApiResponse<ProductAdminDto>>('POST', base(productId), {
      json: req,
    });
    return unwrap(res);
  },

  async revoke(productId: number, userId: number): Promise<void> {
    await request<void>('DELETE', `${base(productId)}/${userId}`);
  },
};
